<template>
  <div
    class="form__field-box select-public"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <label class="form__label" v-if="labelHtml" v-html="labelHtml"></label>
    <label class="form__label" v-else="label">
      {{ label }}
    </label>
    <div
      class="v-input v-input__select"
      :class="{
        'v-input--is-dirty': isDirty,
        'v-input--is-disabled': disabled,
        'v-input__select--is-open': selectToggleState,
        'v-input__error--border': !!errors.has(newName),
      }"
    >
      <select
        class="v-input__field v-input__field--select fontawesome-select"
        v-model="model"
        type="text"
        :name="name"
        :disabled="disabled"
        @change="$emit('input', model), toggleSelect, $emit('change', model)"
        @blur="setSelectFalse"
        @mouseup="toggleSelect"
      >
        <option
          v-if="zeroOption && showZeroOption == 1"
          key="zero-option"
          value="0"
        >
          {{ zeroOption }}
        </option>
        <option
          v-else-if="showZeroOption == 1"
          key="zero-option"
          :value="``"
        ></option>
        <option
          v-for="(option, key) in options"
          :key="`${key}-option`"
          :value="key"
        >
          {{ option }}
        </option>
      </select>

      <span class="v-input__select__icon">
        <i class="fa fa-angle-down"></i>
      </span>

      <!--       <div class="v-input__error" v-if="errors.has(newName)">
            {{ errors.first(newName) }}
        </div> -->
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";

export default {
  data() {
    return {
      selectToggleState: false,
    };
  },
  computed: {
    isDirty() {
      return this.model !== null;
    },
  },
  mixins: [field],
  props: {
    options: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    labelHtml: {
      default() {
        return "";
      },
      type: String,
    },
    zeroOption: {
      default() {
        return "";
      },
      type: String,
    },
    showZeroOption: {
      default() {
        return "1";
      },
      type: String,
    },
  },
  watch: {
    errors: function (value) {},
  },
  methods: {
    toggleSelect() {
      return this.selectToggleState
        ? this.setSelectFalse()
        : this.setSelectTrue();
    },
    setSelectTrue() {
      return (this.selectToggleState = true);
    },
    setSelectFalse() {
      return (this.selectToggleState = false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/admin/components/VSelectPublic.vue